import { action, makeObservable } from 'mobx';
import { BaseViewStore } from 'core/stores';
import { ProductPartForm } from 'modules/product/forms';
import MultiPackageProductStore from './MultiPackageProductStore';
import { sourceOfChange } from 'common/constants';
import _ from 'lodash';

class UpdateProductPartModalContentViewStore extends BaseViewStore {
	updateProductPartForm = new ProductPartForm({
		onSuccess: async () => {
			await this.updateProductPart();
			this.modalParams.success();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.parentView = this.rootStore.productDetailViewStore;
		this.modalParams = modalParams;
		this.multiPackageProductStore = new MultiPackageProductStore(rootStore);
		this.initialize();
	}

	@action initialize = async () => {
		this.updateProductPartForm.$('productId').value = this.modalParams.data.productId;
	};

	@action.bound updateProductPart = async () => {
		const { productId, quantity } = this.updateProductPartForm.values();

		const multiPackageProduct = {
			id: this.modalParams.data.id,
			parentProductId: this.rootStore.routerStore.routerState.params.id,
			productId,
			quantity,
		};

		await this.multiPackageProductStore.update(multiPackageProduct, sourceOfChange.updateProductCombination);
		this.rootStore.notificationStore.success('PRODUCTDETAILVIEW.UPDATEPRODUCTPARTMODAL.PRODUCTPARTUPDATESUCCESS');
	};
}

export default UpdateProductPartModalContentViewStore;
